// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3Tgxu","title":"Info_title__lpCB1","selects":"Info_selects__1GET4","requiredAsterisk":"Info_requiredAsterisk__z_61q"};